export default "__VITE_ASSET__CvXocHZy__"